import type { CSSProperties } from 'react';
import { Paperclip, Scissors, Undo2 } from 'lucide-react';
import './boundary-pending.css';

/**
 * A split or join that has been accepted and is waiting to be saved, shown on
 * the boundary itself. It takes the place of the control that made it, so
 * nothing around it moves, and it says the one thing that is true: "Saving…".
 */
export function BoundaryPendingMark({
  kind,
  pageNumber,
  className = '',
  style,
}: {
  kind: 'split' | 'join' | 'undo';
  /** The batch page the change is about, for anything that needs to find this mark. */
  pageNumber?: number;
  className?: string;
  style?: CSSProperties;
}) {
  const label =
    kind === 'split'
      ? 'New document start saving'
      : kind === 'join'
        ? 'Join saving'
        : 'Undo saving';
  return (
    <span
      className={`boundary-pending ${className}`.trim()}
      style={style}
      role="status"
      aria-busy="true"
      aria-label={label}
      data-boundary-page={pageNumber}
      data-boundary-kind={kind}
    >
      {kind === 'split' ? (
        <Scissors size={13} aria-hidden="true" />
      ) : kind === 'join' ? (
        <Paperclip size={13} aria-hidden="true" />
      ) : (
        <Undo2 size={13} aria-hidden="true" />
      )}
      <span aria-hidden="true">Saving…</span>
    </span>
  );
}
